import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductAttributesComponent } from "@spartacus/storefront";

@Component({
    selector: 'gen-product-attributes',
    templateUrl: './product-attributes.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GenProductAttributesComponent extends ProductAttributesComponent { }
